import React from "react";

const Modal = ({ modalref, show, onClose, children, sample }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-backdrop">
      <div ref={modalref} className={`${sample ? "sample-modal max-[500px]:w-[80%]" : "modal-content"}`}>
        {children}
        {sample ? <></> : <button className="modal-close mt-5 md:mt-10" onClick={onClose}>
          <p className="text-base text-ctaorange font-medium">Close</p>
        </button>}
      </div>
    </div>
  );
};

export default Modal;
